import { render, staticRenderFns } from "./News2.vue?vue&type=template&id=20d95b4c&scoped=true&"
import script from "./News2.vue?vue&type=script&lang=js&"
export * from "./News2.vue?vue&type=script&lang=js&"
import style0 from "./News2.vue?vue&type=style&index=0&id=20d95b4c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d95b4c",
  null
  
)

export default component.exports